import { Result, Uuid, Validator } from '@standardnotes/domain-core';
export class AddAuthenticator {
    constructor(authenticatorClient, authenticatorRegistrationPromptFunction) {
        this.authenticatorClient = authenticatorClient;
        this.authenticatorRegistrationPromptFunction = authenticatorRegistrationPromptFunction;
    }
    async execute(dto) {
        var _a;
        if (!this.authenticatorRegistrationPromptFunction) {
            return Result.fail('Could not generate authenticator registration options: No authenticator registration prompt function provided');
        }
        const userUuidOrError = Uuid.create(dto.userUuid);
        if (userUuidOrError.isFailed()) {
            return Result.fail(`Could not generate authenticator registration options: ${userUuidOrError.getError()}`);
        }
        const userUuid = userUuidOrError.getValue();
        const authenticatorNameValidatorResult = Validator.isNotEmpty(dto.authenticatorName);
        if (authenticatorNameValidatorResult.isFailed()) {
            return Result.fail(`Could not generate authenticator registration options: ${authenticatorNameValidatorResult.getError()}`);
        }
        const registrationOptions = (_a = dto.registrationOptions) !== null && _a !== void 0 ? _a : (await this.authenticatorClient.generateRegistrationOptions());
        if (registrationOptions === null) {
            return Result.fail('Could not generate authenticator registration options');
        }
        let authenticatorResponse;
        try {
            authenticatorResponse = await this.authenticatorRegistrationPromptFunction(registrationOptions);
        }
        catch (error) {
            if (error.name === 'InvalidStateError') {
                return Result.fail('Authenticator was probably already registered by user');
            }
            else {
                return Result.fail(`Could not generate authenticator registration options: ${error.message}`);
            }
        }
        const verificationResponse = await this.authenticatorClient.verifyRegistrationResponse(userUuid, dto.authenticatorName, authenticatorResponse);
        if (!verificationResponse) {
            return Result.fail('Could not verify authenticator registration response');
        }
        return Result.ok();
    }
}
